/**
 * Microwave Persona - Avatar Prompts (Arabic)
 *
 * Arabic translations of scripts/prompts for what the avatar says during each module.
 * Mirrors the structure of prompts.js exactly.
 */

export const modulePrompts = {
  'intro-microwaves': `مرحباً!   أنا نيكس. عندما يسمع معظم الناس كلمة "ميكروويف" فإنهم يفكرون في فرن الميكروويف.   لكن في عالم الهندسة،   الميكروويف هو العمود الفقري الخفي للحياة الحديثة—فهو يشغل كل شيء من الواي فاي ونظام التموضع العالمي   إلى التلفزيون الفضائي واستكشاف الفضاء السحيق.

في هذه الوحدة،   سنحدد مكان الميكروويف في الطيف   ولماذا طول موجته "القصير" يعد أمراً مهماً للتكنولوجيا.`,

  'microwave-window-pdf': `دعني أعرض عليك قراءة حول نافذة الميكروويف—حيث يشغل الميكروويف الطيف الكهرومغناطيسي بين 300 ميجاهرتز و 300 جيجاهرتز،   ولماذا أطواله الموجية القصيرة نسبياً   تجعله يتصرف أشبه بالضوء منه بموجات الراديو التقليدية،   متجهاً في خطوط مستقيمة،   بالخط البصري.`,

  'quiz-microwave-basics': `ممتاز!   الآن وقد تعلمت عن طيف الميكروويف،   لنجرب فهمك باختبار سريع.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'waveguides-components': `عند ترددات الميكروويف،   الكهرباء تتصرف... بغرابة.   أسلاك النحاس العادية تبدأ بالتصرّف كهوائيات   وتسرب الطاقة في كل مكان!   لنقل هذه الإشارات،   يتعين علينا استخدام معدات متخصصة   مثل الموجات الدليلية والشرائح الدقيقة.

لنشاهد فيديو قصيراً حول هذا الموضوع:   أساسيات تقنية الموجات الدليلية وانتشار الميكروويف.`,

  'waveguide-video': `يرجى مشاهدة هذا الفيديو عن تقنية الموجات الدليلية وانتشار الميكروويف.   سأكون هنا عند انتهائه.`,

  'quiz-hardware-physics': `ممتاز!   الآن لنجرب معرفتك بأجهزة الميكروويف والفيزياء.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'radar-satellite': `الآن،   لنتتبع هذا في العمل.   لأن الميكروويف يمكنه اختراق السحب والمطر،   فهو مثالي للرادار والاتصالات الساتلية.   سواءً كانت محطة تتبع الطقس   أو قمراً صناعياً على بعد 22,000 ميل في الفضاء،   الميكروويف هو أداة الاختيار.

قراءة:   حالات استخدام الميكروويف.   الرادار:   إرسال نبضة وقياس "الصدى" لمعرفة المسافة والسرعة.   الروابط نقطة لنقطة:   تلك الهوائيات الكبيرة على شكل أسطوانة التي تراها على أبراج الخلايا.   الروابط الساتلية:   استخدام النطاق "سي" أو "كيو" لبث البيانات حول العالم.`,

  'final-quiz': `ممتاز!   وصلت إلى الاختبار النهائي.

لنرى كم تعلمت عن تقنية الميكروويف وتطبيقاتها.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.

مستعد؟   لنبدأ!`,
};

export const moduleTransitionPrompts = {
  'quiz-microwave-basics': `عمل رائع في إكمال قسم مقدمة الميكروويف!   أنت الآن تفهم أساسيات طيف الميكروويف والانتشار بالخط البصري.

بعد ذلك،   سنتعمق في الموجات الدليلية والمكونات—المعدات المتخصصة التي تجعل أنظمة الميكروويف تعمل.

هل لديك أسئلة عما غطيناه حتى الآن؟   قل "متابعة" عندما تكون جاهزاً للمتابعة.`,

  'quiz-hardware-physics': `ممتاز!   أنت الآن تفهم الموجات الدليلية وتأثير الجلد ولماذا الأسلاك العادية لا تعمل عند ترددات الميكروويف.

في القسم الأخير،   سنستكشف الرادار والاتصالات الساتلية—التطبيقات الواقعية للميكروويف.

هل لديك أسئلة قبل المتابعة؟   قل "متابعة" عندما تكون جاهزاً.`,
};

export const videoCompletionPrompts = {
  'waveguide-video': `كانت تلك نظرة رائعة على تقنية الموجات الدليلية وانتشار الميكروويف!

آمل أن تكون قد استفدت.   إذا كان لديك أي أسئلة عما شاهدته للتو،   لا تتردد في السؤال.   إذا أردت مشاهدة الفيديو مرة أخرى،   قل فقط "كرر الفيديو".

عندما تكون جاهزاً لاختبار سريع عن الأجهزة والفيزياء،   قل "متابعة".`,
};

export const courseCompletionPrompt = `عمل مذهل!   لقد انتقلت من الترددات الأساسية   إلى الأجهزة المعقدة   والتطبيقات العالمية.   أنت الآن تفهم "المسارات" الخفية في الهواء   التي تجعل العالم الحديث ممكناً.   أنت رسمياً محترف تقنية الميكروويف!`;

export const welcomeMessage = "مرحباً! أنا نيكس. أهلاً بك في تقنية الميكروويف. لنستكشف العمود الفقري الخفي للحياة الحديثة—من الواي فاي ونظام التموضع العالمي إلى التلفزيون الفضائي واستكشاف الفضاء السحيق!";

const microwavePrompts = {
  modulePrompts,
  moduleTransitionPrompts,
  videoCompletionPrompts,
  courseCompletionPrompt,
  welcomeMessage,
};

export default microwavePrompts;
